module.exports = __webpack_public_path__ + "static/media/stage8.75f31fa9.svg";